import React from 'react';
import { fetchSessionOnce, invalidateSessionCache } from './SessionSingleFlight';
import { clearSWRCache } from '../../utils/fetchWithSWR';
import { isPublicRoute } from '../auth/publicRoutes';

export function SessionManager() {
  React.useEffect(() => {
    if (isPublicRoute()) return;

    let cancelled = false;
    let lastReactTs = 0;
    const REACT_COOLDOWN_MS = 1500;

    const bc = typeof window !== 'undefined' && 'BroadcastChannel' in window
      ? new BroadcastChannel('experience-auth')
      : null;

    const check = async () => {
      try {
        const j = await fetchSessionOnce();
        if (!cancelled && !(j as any)?.authenticated) {
          const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.replace(`/auth/login?return_to=${returnTo}`);
        }
      } catch {}
    };

    const onFocus = () => { invalidateSessionCache(); check(); };
    const onVisibility = () => { if (document.visibilityState === 'visible') { invalidateSessionCache(); check(); } };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    bc?.addEventListener('message', (e) => {
      const data = (e as MessageEvent).data as any;
      if (!data || data.type !== 'session-updated') return;
      const now = Date.now();
      if (now - lastReactTs < REACT_COOLDOWN_MS) return;
      lastReactTs = now;
      // Auth/session changed in another tab: avoid cross-user/cache bleed.
      clearSWRCache();
      invalidateSessionCache();
      check();
    });

    // Initial
    check();

    return () => {
      cancelled = true;
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
      bc?.close();
    };
  }, []);

  return null;
}


